export default "__VITE_ASSET__2e56659c__"